registerComponent("blocks/card-content-v2", function (component) {
/**
 * blocks/card-content-v2 — SEM COMPORTAMENTO, de propósito.
 *
 * O cartão inteiro é um `<a>` (ou um `<li>` com um `<a>` que cobre a área):
 * clique, foco, Enter, abrir em nova aba e copiar endereço já são do navegador.
 * Um `addEventListener('click')` aqui só teria como efeito quebrar o
 * Ctrl+clique.
 *
 * As animações de entrada são CSS (`_card-content-v2.less`), disparadas pela
 * classe que `Asa.revelar()` escreve — e mesmo essa é opcional: o estado base da
 * folha já é o estado FINAL, então sem JS o cartão aparece normalmente.
 *
 * O arquivo existe para não haver dúvida de que a ausência é decisão, e não
 * esquecimento — é o mesmo padrão de `pages/contents/_contents.js`.
 */

});
